<template>
    <div>
        <transition :name="transition" :mode="mode">
            <slot></slot>
        </transition>
        <!-- <div class="overlay-top"></div> -->
        <!-- <div class="overlay-right"></div> -->
        <div class="overlay__bottom">
            <div class="overlay__inner"></div>
        </div>
        <!-- <div class="overlay-left"></div> -->
    </div>
</template>


<script>
export default {
    name: 'page-transition',
    props: ['name'],
    data() {
        return {
            transition: 'fade',
            mode: 'out-in',
        }
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            this.transition = to.meta.transition ?
                to.meta.transition :
                this.$props.name

            next()
        })
    }
};
</script>



<style scoped lang="scss">
    // @import "@/scss/modules/_transitions.scss";
</style>